<template>
  <div id="volumepricing" class="mkt-ops -main-font">
    <div
      style="position: absolute; top: 50%; left: 52%; width: 10%; z-index: 2"
      v-show="loadData == true"
    >
      <md-progress-spinner
        :md-stroke="8"
        :md-diameter="65"
        md-mode="indeterminate"
      ></md-progress-spinner>
      <div v-if="loadData" class="bg-overlay-unset" style="z-index: 15"></div>
    </div>
    <div
      style="position: absolute; top: 50%; left: 52%; width: 10%; z-index: 2"
      v-show="loadDataSave == true"
    >
      <md-progress-spinner
        :md-stroke="8"
        :md-diameter="65"
        md-mode="indeterminate"
      ></md-progress-spinner>
      <div
        v-if="loadDataSave"
        class="bg-overlay-unset"
        style="z-index: 15"
      ></div>
    </div>

    <div class="md-layout-item md-size-100">
      <label class="title">VOLUME DISCOUNT</label>
    </div>

    <div class="mktops-control-box">
      <div class="head-search-price md-layout">
        <div
          class="
            mktops-subheader-filter
            md-layout-item md-large-size-10 md-medium-size-10 md-small-size-10
          "
        >
          <md-field class="box">
            <md-select v-model="slcProduct" id="select-price-unit">
              <!-- @md-selected="onChangeSearch('select')" -->
              <md-option
                v-for="(item, index) in status"
                :key="index"
                :value="index"
                >{{ item }}</md-option
              >
            </md-select>
          </md-field>
        </div>
        <md-field
          class="
            md-search-box
            md-layout-item
            md-large-size-30
            md-medium-size-30
            md-small-size-30
          "
        >
          <i class="md-icon material-icons">search</i>
          <md-input
            type="text"
            placeholder="Search with Title,Product"
            v-model="searchList"
          ></md-input>
          <!-- @input="onChangeSearch('input')" -->
        </md-field>
        <div
          class="
            search-create-user
            md-layout-item md-large-size-20 md-medium-size-20 md-small-size-20
          "
        >
          <multiselect
            v-model="selectedUserCreate"
            id="usercreate"
            label="firstname"
            track-by="username"
            placeholder="User Create"
            :open-direction="'bottom'"
            :options="optionsUserCreate"
            :searchable="true"
            :max-height="180"
            :show-no-results="false"
            :custom-label="customLabelUserCreate"
            :select-label="''"
            :deselect-label="''"
            :selected-label="''"
            :hide-selected="true"
          >
            <!-- @select="setDataUserCreate" -->
            <template slot="singleLabel" slot-scope="{ option }">
              <div>
                <div
                  class="-label"
                  style="font-family: kanit; padding-top: 3px"
                >
                  {{ option.firstname }} {{ option.lastname }}
                </div>
                <div
                  class="-delete"
                  style="padding-top: 2px; margin-right: 8px"
                  @mousedown.prevent.stop="clearAll(option.username)"
                >
                  <i class="material-icons">close</i>
                </div>
              </div>
            </template>
          </multiselect>
        </div>
        <div
          class="
            mktops-subheader-filter
            md-layout-item md-large-size-20 md-medium-size-20 md-small-size-20
          "
        >
          <md-button
            class="md-raised md-primary"
            style="margin-top: 10px; border-radius: 3px; margin-left: 12px"
            @click="onChangeSearch()"
          >
            SEARCH
          </md-button>

          <md-button
            class="md-raised md-primary"
            style="
              margin-top: 10px;
              border-radius: 3px;
              margin-left: 0px;
              background: #bebfbf;
            "
            @click="onChangeSearch('clear')"
          >
            CLEAR
          </md-button>
        </div>
        <div
          class="
            btn-create
            md-layout-item md-large-size-15 md-medium-size-15 md-small-size-15
          "
        >
          <!-- v-show="checkAccess && isAdd" -->
          <md-button
            v-show="isAdd"
            ref="createBtn"
            class="md-raised md-primary"
            id="btn-price-create"
            @click="onClickCreate('true')"
          >
            <i class="md-icon material-icons">add</i>CREATE
          </md-button>
        </div>
      </div>
    </div>

    <div id="table-volume-pricing">
      <div id="divHeadList">
        <div style="width: 7%">VD ID</div>
        <div style="width: 25%">Title</div>
        <div style="width: 16%" class="-text-right">Qty Steps</div>
        <div style="width: 7%" class="-text-right">Items</div>
        <div style="width: 9.5%" class="-text-right">Type</div>
        <div
          style="width: 6.5%; padding-right: 10px"
          class="-usage -text-right"
        >
          Usage
        </div>
        <div style="width: 15%; padding-left: 20px">Modify date</div>
        <div style="width: 14%">Create By</div>
        <!-- <div style="width: 5%;" class="-text-center"></div> -->
      </div>
      <div id="divBodyList" @scroll="handleScroll">
        <!-- v-show="!checkAccess" -->
        <div
          v-show="tbListProduct.length === 0"
          :class="'row-bg-gray'"
          style="display: block; text-align: center; font-size: 14px"
        >
          <!-- Not have permission to view information. -->
          No data in table.
        </div>
        <div
          :class="'row-bg-gray -pointer'"
          v-for="(item, rIndex) in tbListProduct"
          :key="rIndex"
          @click="onSelect(item)"
        >
          <div style="width: 7%">
            {{ item.vd_id }}
          </div>
          <div style="width: 25%" class="nowrap-title -font-kanit">
            <span :title="item.h_name">{{ item.h_name }}</span>
          </div>
          <div
            v-if="item.qty_c3 === null"
            style="width: 16%"
            class="-text-right"
          >
            {{ formatNumber(item.qty_a3[0].end, 0) }}, 0,
            {{ formatNumber(item.qty_c2[0].end, 0) }},
            {{ formatNumber(item.qty_c1[0].end, 0) }},
            {{ formatNumber(item.qty_c0[0].start, 0) }}+
          </div>
          <div v-else style="width: 16%" class="-text-right">
            {{ formatNumber(item.qty_a3[0].end, 0) }},
            {{ formatNumber(item.qty_c3[0].end, 0) }},
            {{ formatNumber(item.qty_c2[0].end, 0) }},
            {{ formatNumber(item.qty_c1[0].end, 0) }},
            {{ formatNumber(item.qty_c0[0].start, 0) }}+
          </div>
          <!--<div style="width: 16%" class="-text-right">{{ formatNumber(item.qty_a3[0].end, 0) }}, {{ formatNumber(item.qty_c2[0].end, 0) }}, {{ formatNumber(item.qty_c1[0].end, 0) }}, {{ formatNumber(item.qty_c0[0].start, 0) }}+</div>-->
          <div style="width: 7%" class="-text-right">
            {{ countDetails(item) }}
          </div>
          <div style="width: 9.5%" class="-text-right">{{ item.type }}</div>
          <div
            v-if="item.usage"
            style="width: 6.5%; padding-right: 10px"
            class="-text-right"
          >
            {{ item.usage }}
          </div>
          <div
            v-else
            style="width: 6.5%; padding-right: 10px"
            class="-text-right"
          >
            0%
          </div>
          <div style="width: 15%; padding-left: 20px">
            {{ formatDate(item.u_date) }}
          </div>
          <!-- <div style="width: 13%;" class="-font-kanit">{{ item.c_user }}</div> -->
          <div style="width: 14%" class="-font-kanit">
            {{ item.firstname }} {{ item.lastname }}
          </div>
          <!-- <div style="width: 5%" class="-text-center">
                    <md-icon>reorder</md-icon>
                </div> -->
        </div>
      </div>
      <div class="footer-table">
        number of lines in page ({{ tbListProduct.length }})
      </div>
    </div>

    <DialogUpdateDiscount
      v-if="vClickEdit == 'true'"
      ref="dialogUpdateDiscount"
      v-model="product"
      :dataDetail="dataDetail"
      @clickDelete="onClickDelete"
      @clickSave="onClickSave"
      @clickCancel="onClickCancel"
    ></DialogUpdateDiscount>
  </div>
</template>

<script>
import PricingService from "@/services/pricing";
import DialogUpdateDiscount from "./../pricing/dialog-update-discount";
import moment from "moment-timezone";

export default {
  name: "volume-pricing-page",
  components: {
    DialogUpdateDiscount: DialogUpdateDiscount,
  },
  computed: {
    permit() {
      return this.$jwt.decode(localStorage.getItem("token"));
    },
    isAdd() {
      return this.permit.acl["overview"].menus["volume-pricing"].add;
    },
  },
  data() {
    return {
      slcProduct: 0,
      status: ["Product", "VD Name", "VD ID"],
      searchList: "",
      checkItem: false,
      tbListProduct: [],
      product: [],
      dataDetail: [],
      vClickEdit: false,
      vClickCreate: false,
      vSearch: "",
      scroll_start: [0],
      search_val: "",
      loadData: true,
      loadDataSave: false,
      selectedUserCreate: [],
      optionsUserCreate: [],
      //   checkAccess: true
    };
  },
  created() {
    this.getDataList("", "");
  },
  methods: {
    customLabelUserCreate({ firstname, lastname }) {
      return `${firstname} ${lastname}`;
    },
    setDataUserCreate(selectedOption) {
      // this.getAllProduct(datas);
      this.onSearch({
        type: this.slcProduct,
        keyword: this.searchList,
        username: selectedOption.username,
      });
    },
    clearAll(id, type) {
      this.selectedUserCreate = [];
      // this.getAllProduct();
      // this.onSearch({
      //   type: this.slcProduct,
      //   keyword: this.searchList,
      //   username: this.selectedUserCreate.username,
      // });
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    getDataList(dataSaves, dataSearch) {
      this.loadData = true;
      PricingService.getDiscount(dataSearch)
        .then((response) => {
          if (response.data) {
            if (this.search_val == dataSearch.keyword) {
              for (let i = 0; i < response.data.length; i++) {
                this.tbListProduct.push(response.data[i]);
              }
            } else {
              this.tbListProduct = response.data;
              this.search_val = dataSearch.keyword;
            }
            if (
              dataSaves !== undefined &&
              dataSaves != "" &&
              dataSaves._id != ""
            ) {
              this.setDataDetail(dataSaves);
            }
            this.loadData = false;
            this.loadDataSave = false;

            // if (response.data.length === 0 && response.user.length === 0) {
            //   this.checkAccess = false;
            // } else {
            //   this.checkAccess = true;
            // }
          }

          this.optionsUserCreate =
            response.user !== undefined
              ? response.user.sort((a, b) =>
                  a.firstname > b.firstname ? 1 : -1
                )
              : [];
        })
        .catch();
    },
    setDataDetail(item) {
      this.product = item;
      this.checkItem = true;
      this.loadDataSave = true;
      this.getDataDetail(item);
    },
    getDataDetail(item) {
      this.checkItem = true;
      //this.selected = item;
      this.dataDetail = [];
      var vDataDetail = this.tbListProduct.find((a) => a._id === item._id);
      if (vDataDetail.details !== undefined) {
        this.dataDetail = vDataDetail.details;
      }
      this.loadDataSave = false;
    },
    handleScroll(event) {
      if (
        event.target.scrollTop + event.target.clientHeight >=
        event.target.scrollHeight
      ) {
        this.onHandleScroll({
          start: this.tbListProduct.length,
          length: 20,
        });
      }
    },
    onHandleScroll(dataScroll) {
      this.loadData = true;
      let dataSearch = [];
      if (!this.scroll_start.includes(dataScroll.start)) {
        this.scroll_start.push(dataScroll.start);
        dataSearch = {
          type: this.vSearch.type,
          keyword: this.vSearch.keyword,
          start: dataScroll.start,
          limit: dataScroll.length,
          username: this.selectedUserCreate.username,
        };
        this.getDataList("", dataSearch);
      } else {
        this.loadData = false;
      }
    },
    formatNumber(value, dicimal) {
      if (isNaN(parseFloat(value))) {
        return value;
      } else {
        if (value % 1 == 0) {
          // return true = int
          return parseFloat(value).toLocaleString(undefined, {
            minimumFractionDigits: dicimal,
            maximumFractionDigits: dicimal,
          });
        } else {
          let parts = value.toString().split(".");
          let num = (parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ","));
          let digit = parts[1].slice(0, 2);
          digit = digit.length < 2 ? digit + "0" : digit;
          return num + "." + digit;
          // return parts.join(".");
        }
      }
    },
    countDetails(vDetails) {
      return this.formatNumber(vDetails.details.length, 0);
    },
    onSelect(item) {
      this.loadData = true;
      this.setDataDetail(item);
      let arrCodes = [];
      for (let i = 0; i < item.details.length; i++) {
        arrCodes.push(item.details[i].item_code);
      }

      let self = this;
      PricingService.getListItems(arrCodes)
        .then((response) => {
          // console.log("response ==>", response);
          for (let i = 0; i < self.dataDetail.length; i++) {
            self.dataDetail[i]["cost"] = "";
            self.dataDetail[i]["qty_a3"] = "";
            self.dataDetail[i]["qty_c3"] = "";
            self.dataDetail[i]["qty_c2"] = "";
            self.dataDetail[i]["qty_c1"] = "";
            self.dataDetail[i]["qty_c0"] = "";

            let vCost = response["cost"].find(
              (a) => a.iprod === self.dataDetail[i].item_code
            );
            if (vCost !== undefined) {
              self.dataDetail[i]["cost"] = vCost.cost_conv;
            }

            let vStock = response["stock"].find(
              (a) => a.iprod === self.dataDetail[i].item_code
            );
            if (vStock !== undefined) {
              self.dataDetail[i]["stock"] = vStock.balance;
            }

            let vPrice = response["price"].find(
              (a) => a._id === self.dataDetail[i].item_code
            );
            if (vPrice !== undefined) {
              if (vPrice.price !== undefined && vPrice.price.A3 !== undefined) {
                self.dataDetail[i]["qty_a3"] = vPrice.price.A3;
              }
              if (vPrice.price !== undefined && vPrice.price.C3 !== undefined) {
                self.dataDetail[i]["qty_c3"] = vPrice.price.C3;
              }
              if (vPrice.price !== undefined && vPrice.price.C2 !== undefined) {
                self.dataDetail[i]["qty_c2"] = vPrice.price.C2;
              }
              if (vPrice.price !== undefined && vPrice.price.C1 !== undefined) {
                self.dataDetail[i]["qty_c1"] = vPrice.price.C1;
              }
              if (vPrice.price !== undefined && vPrice.price.C0 !== undefined) {
                self.dataDetail[i]["qty_c0"] = vPrice.price.C0;
              }
            }
          }

          // console.log("this.dataDetail ==>", this.dataDetail);
          let path = this.$route.path;
          let arr_path = path.split("/");
          let acl = this.$jwt.decode(localStorage.getItem("token")).acl;
          this.vClickEdit = "true";
          this.loadData = false;
        })
        .catch();
    },
    onClickCreate(valCreate) {
      this.product = [];
      this.dataDetail = [];
      this.vClickEdit = valCreate;
      this.vClickCreate = valCreate;
      this.checkItem = false;
    },
    onChangeSearch(type) {
      // if (this.searchList != "") {
      //   this.onSearch({
      //     type: this.slcProduct,
      //     keyword: this.searchList,
      //     username: this.selectedUserCreate.username,
      //   });
      // } else {
      //   if (type == "input") {
      //     this.onSearch({
      //       type: this.slcProduct,
      //       keyword: this.searchList,
      //       username: this.selectedUserCreate.username,
      //     });
      //   }
      // }

      if (type == "clear") {
        this.slcProduct = 0;
        this.searchList = "";
        this.selectedUserCreate = [];

        // this.onSearch({
        //   type: this.slcProduct,
        //   keyword: this.searchList,
        //   username: "",
        // });
      } else {
        this.onSearch({
          type: this.slcProduct,
          keyword: this.searchList,
          username: this.selectedUserCreate.username,
        });
      }
    },
    onSearch(search) {
      this.scroll_start = [];
      this.tbListProduct = [];
      this.vSearch = search;
      this.getDataList("", search);
    },
    onClickDelete(_id) {
      this.vClickCreate = false;
      this.vClickEdit = false;
      this.loadData = true;
      this.loadDataSave = true;
      this.checkItem = false;
      this.scroll_start = [];
      this.tbListProduct = [];
      PricingService.deleteDiscount(_id)
        .then((response) => {
          this.getDataList("", this.vSearch);
        })
        .catch();
    },
    onClickSave(dataSaves) {
      // console.log("dataSaves ==>", dataSaves);
      this.vClickCreate = false;
      this.vClickEdit = false;
      this.loadData = true;
      this.loadDataSave = true;
      PricingService.saveDiscount(dataSaves)
        .then((response) => {
          // this.product = response;
          // console.info('--dataSaves--', response);
          if (response.length > 0) {
            if (response[0].type == false) {
              // console.log("เลือก item ซ้ำ");
              this.tbListProduct = [];
              this.getDataList(dataSaves, this.vSearch);
            } else {
              // console.log("save succes");
              this.tbListProduct = [];
              this.getDataList(dataSaves, this.vSearch);
            }
          }
        })
        .catch();
    },
    onClickCancel(datas) {
      if (datas != "close") {
        this.dataDetail = datas;
      }
      this.vClickCreate = false;
      this.vClickEdit = false;
    },
  },
};
</script>

<style lang="scss">
#volumepricing {
  background-color: #fff;
  padding: 18px 18px;
  font-family: lato;

  .row-bg-gray:hover {
    border-radius: 4px;
    background: rgba(236, 236, 235, 1);

    &.-pointer {
      cursor: pointer;
    }
  }

  .title {
    font-size: 18px;
    font-weight: bold;
    color: #797979;
  }

  .mktops-control-box {
    margin-top: 10px;
    width: 100%;

    .head-search-price {
      display: flex;

      .mktops-subheader-filter {
        height: 38px;

        .md-field.box > .md-input.md-select-value,
        .md-field.box > .md-menu.md-select {
          font-size: 14px;
          width: 115.72px;
          height: 36px;
          margin: 10px 9.28px 0 4px;
        }

        .md-field.md-field.box {
          margin-top: unset;
          margin-bottom: unset;
          padding: unset;
        }

        .md-field:after,
        .md-field:before {
          left: unset;
        }

        .md-field.box .md-input.md-input.md-select-value,
        .md-field.box label {
          font-size: 14px;
          padding-left: 12px;
          padding-top: 3px;
          color: #727272;
        }

        .md-field.box .md-select {
          background-color: #efefef;
          border-radius: 3px;
        }
      }

      .md-search-box {
        margin: 10px 10px 10px 0px;
        padding-top: unset;
        width: 355px;
        border-radius: 3px;
        min-height: 36px;
        box-shadow: 0 0 3px rgba(0, 0, 0, 0.16), 0 0 0 rgba(0, 0, 0, 0),
          0 1px 1px -2px rgba(0, 0, 0, 0);

        .md-icon.material-icons {
          margin-left: 17px;
          margin-top: 7px;
          color: #000000;
          opacity: 0.54;
        }

        .md-input {
          height: 36px;
          margin-left: 12.43px;
          font-size: 14px;
          // font-family: kanit;
        }

        &.md-field > .md-icon:after,
        &.md-field:after,
        &.md-field:before {
          content: none;
        }
      }

      .search-create-user {
        width: 20%;
        margin-top: 3px;
        padding-left: 5px;

        .multiselect {
          font-weight: 300;

          .z-index-top {
            z-index: 10;
          }

          margin: 5px 0px;

          .multiselect__single,
          .multiselect__input {
            font-size: 14px;

            div {
              display: flex;
              width: 100%;

              .-delete {
                width: 5%;
                margin: 0px 5px;

                .material-icons {
                  font-size: 18px;
                  margin-top: 1px;
                  cursor: pointer;
                  color: gray;
                }
              }
            }
          }

          .multiselect__tags {
            padding: 8px 30px 0 8px;

            input {
              font-family: lato;
              font-weight: 300;
            }

            .multiselect__placeholder {
              margin: 0px;
            }

            ::placeholder {
              color: #bdbdbd;
              opacity: 1;
            }
          }

          .multiselect__content-wrapper {
            font-size: 14px;
            z-index: 10;
            font-family: kanit;
          }

          .multiselect__option {
            min-height: 34px;
            padding: 12px 12px 0px 12px;
          }

          ::-webkit-scrollbar {
            width: 8px;
            height: 8px;
          }
        }
      }

      .btn-create {
        width: 34%;
        text-align: right;
        padding-top: 3px;

        button {
          margin-top: 8px;
          margin-right: 0px;
          padding: 2px 5px 0 5px;
          width: 120px;
          // height: 32px;
          box-shadow: unset;
          font-family: lato;
          font-size: 12px;
          font-weight: bold;
          border-radius: 3px;

          .md-ripple {
            padding-left: 4px;
          }

          .md-icon {
            font-size: 16px !important;
            margin-right: 5px;
            margin-top: 5px;
          }
        }
      }
    }
  }

  #table-volume-pricing {
    .md-checkbox {
      display: flex;
      margin-top: 0px;
      margin-bottom: 0px;
      padding-left: 0px !important;
    }

    #divHeadList {
      width: 99.6%;
      display: -webkit-inline-box;
      font-size: 13px;
      font-weight: bold;
      margin-top: 15px;
      margin-bottom: 13px;

      div {
        // border: 1px solid pink;
        padding-left: 5px;
        padding-right: 5px;
        // color: #414141;

        &.-text-right {
          text-align: right;
        }

        &.-text-center {
          text-align: center;
        }
      }
    }

    #divBodyList {
      width: 100%;
      height: calc(100vmin - 197px);
      display: block;
      overflow-y: scroll;
      // font-size: 13px;
      // font-weight: 300;

      > div {
        width: 100%;
        height: 35px;
        display: -webkit-inline-box;
        padding-top: 5px;
        padding-bottom: 5px;

        div {
          // border: 1px solid pink;
          padding-left: 5px;
          padding-right: 5px;
          // color: #414141;

          &.-text-right {
            text-align: right;
          }

          &.-text-center {
            text-align: center;
          }

          &.nowrap-title {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          // &.-font-kanit {
          //     font-size: 14px;
          //     font-family: kanit;
          // }
        }
      }

      &::-webkit-scrollbar {
        height: 7px;
        width: 5px;
      }
    }

    .footer-table {
      // border: 1px solid pink;
      display: block;
      text-align: center;
      margin-top: 5px;
      width: 99.6%;
      font-size: 14px;
      font-style: italic;
    }
  }
}
</style>
